import { isSameMonth, isSameYear } from '../../../_shared/functions/date-fns-wrappers'
import { normalizeRetainerDates } from '../helpers/retainer-helper'

export interface IRetainerBudget {
  id: string
  retainerId: string
  timeBudget: number
  trackedDuration: number
  startDate: Date | string
  endDate?: Date | string
  createdOn?: Date | string
  createdBy?: string
  updatedOn?: Date | string
  updatedBy?: string
  deletedOn?: Date | string
  deletedBy?: string
}

export class RetainerBudget implements IRetainerBudget {
  id: string
  retainerId: string
  timeBudget: number
  trackedDuration: number
  startDate: Date | string
  endDate?: Date | string
  createdOn?: Date | string
  createdBy?: string
  updatedOn?: Date | string
  updatedBy?: string
  deletedOn?: Date | string
  deletedBy?: string

  constructor(init?: Partial<IRetainerBudget>) {
    Object.assign(this, init)
    normalizeRetainerDates(this)
  }

  /**
   * Checks whether the retainerBudget startDate is on the same month as today.
   * @returns {boolean}
   */
  get isCurrentRetainerBudget(): boolean {
    const today = new Date()
    return isSameYear(this.startDate, today) && isSameMonth(this.startDate, today)
  }
}
